import { footerStyles } from "@insite/content-library/Pages/Footer";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
        margin-top: 3rem;
        padding: 3rem 0;
    `
};
